<template>
    <button
        class="tiptap-btn"
        type="button"
        :title="$t('Numbered list')"
        :disabled="disabled"
        :class="{ 'is-active': editor.isActive('orderedList') }"
        @click="editor.chain().focus().toggleOrderedList().run()">
        <FormatListNumberedIcon size="16"/>
    </button>
</template>

<script>
import FormatListNumberedIcon from '@/common/components/svg-icons/FormatListNumberedIcon.vue';
import {Editor} from '@tiptap/vue-2';

export default {
    name: 'MenuBarNumberedListButton',

    props: {
        editor: {
            type: Editor,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    components: {
        FormatListNumberedIcon
    }
};
</script>
